var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/sidebar-navigation-link.tsx";
import classNames from 'clsx';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon, Text } from './ui';

/** Desktop sidebar navigation link. */
const SidebarNavigationLink = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    icon,
    text,
    to = '',
    count,
    onClick
  } = props;
  const isActive = location.pathname === to;

  const handleClick = e => {
    if (onClick) {
      onClick(e);
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return /*#__PURE__*/React.createElement(NavLink, {
    exact: true,
    to: to,
    ref: ref,
    onClick: handleClick,
    className: classNames({
      'flex items-center px-4 py-3.5 text-base font-semibold space-x-4 rounded-full group text-gray-600 hover:text-gray-900 dark:text-gray-500 dark:hover:text-gray-100 hover:bg-primary-200 dark:hover:bg-primary-900': true,
      'dark:text-gray-100 text-gray-900': isActive
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: icon,
    count: count,
    className: classNames('h-5 w-5', {
      'text-gray-600 dark:text-gray-500 group-hover:text-primary-500 dark:group-hover:text-primary-400': !isActive,
      'text-primary-500 dark:text-primary-400': isActive
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Text, {
    weight: "semibold",
    theme: "inherit",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 7
    }
  }, text));
});
export default SidebarNavigationLink;